<template>
    <div class="row bloque mx-auto">
        <div class="col-2 numero">
            {{ numero }}.
        </div>
        <div class="col-10 texto">
            <span>{{ texto }}</span>
            <img :src="imagen" />
            <a href="#" v-scroll-to="'#contacto'"><img v-if="numero == 3" src="@/assets/images/flecha-aqui.svg" class="flechaAqui" /></a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Trespasos',
  props: {
    texto: String,
    numero: String,
    imagen: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bloque {
    max-width: 350px;
    border: 6px solid #1900FF;
    -moz-box-shadow: 8px 8px 0 #000;
    -webkit-box-shadow: 8px 8px 0 #000;
    box-shadow: 8px 8px 0 #000;
    padding: 10px;
}
.numero {
    font-size: 50px;
    font-weight: 200;
}
.texto {
    padding: 30px 20px;
}
.texto span {
    font-size: 24px;
    font-weight: 800;
    line-height: 0px;
}
img {
    width: 170px;
    position: absolute;
    right: -100px;
    bottom: -94px;
}
img.flechaAqui {
    width: 120px;
    position: absolute;
    right: -152px;
    bottom: -190px;
}
@media only screen and (max-width: 990px){
    img {
        width: 130px;
        position: absolute;
        right: -50px;
        bottom: -80px;
    }
    img.flechaAqui {
        width: 100px;
        margin: 0 auto;
        position: absolute;
        right: 0;
        left: 0;
        bottom: -160px;
    }
    .bloque {
        width: 88%;
    }
    .numero {
        font-size: 50px;
        font-weight: 200;
    }
    .texto {
        padding: 20px 20px;
    }
    .texto span {
        font-size: 20px;
        font-weight: 800;
        line-height: 0px;
    }
}
</style>
